import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import * as api from '../../../actions/api'
import { LiveSettings } from '../components'
import { openingRuleItems } from '../../../constants';

const mapStateToProps = (state) => {
  const { liveId } = state.liveSettings
  const { language } = state.user
  return ({
    liveId,
    language
  })
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return ({
    handleStart: (openingRule, title, blackPlayerName, whitePlayerName) => () => {
      var item, shortOpeningRule
      item = openingRuleItems.find(it => it.value === openingRule)
      shortOpeningRule = item !== undefined ? item.short : ''
      dispatch(api.live.startLiveGame(shortOpeningRule, title, blackPlayerName, whitePlayerName))
    }
  })
}

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(LiveSettings))


// WEBPACK FOOTER //
// ./src/Pages/Live/containers/LiveSettings.js